export default __webpack_public_path__ + "static/media/ongoing1.bd46fda0.png";